import { FC, ReactElement } from 'react'

import { CryptoRewardsPanePreset } from 'components/features/rewards/rewardsPane/components/CryptoRewardsPanePreset/CryptoRewardsPanePreset'
import { getCryptoRewardsPaneProgressPercentsStateSelector } from 'components/features/rewards/rewardsPane/store/selectors/paneState'
import { useStoreSelector } from 'helpers/reactReduxHelpers'

type CryptoRewardsAutoInvestmentsSendingRequestStepProps = {
  onClose: () => void
}

export const CryptoRewardsAutoInvestmentsSendingRequestStep: FC<CryptoRewardsAutoInvestmentsSendingRequestStepProps> = ({
  onClose,
}): ReactElement => {
  const paneProgressPercent = useStoreSelector(getCryptoRewardsPaneProgressPercentsStateSelector)

  return (
    <CryptoRewardsPanePreset
      withoutFooter
      title='Invest Your Rewards Into Crypto'
      subTitle=''
      onCancel={ onClose }
      isLoading
      progressBarPercent={ paneProgressPercent }
    />
  )
}
